// extracted by mini-css-extract-plugin
export default {"row":"ExtendableSharedGridTableRow_row__AOkJ8","cell":"ExtendableSharedGridTableRow_cell__oSQ+L"};